/**
 * RunAgainIcon/index.js
 * desc: rotate feature main navigation icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const RunAgainIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="run-again icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.runAgain.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.9184 12.0361C15.9184 12.6337 15.6448 13.182 15.1659 13.5391L11.5904 16.2212C11.2574 16.4717 10.8631 16.5985 10.4657 16.5985C10.1789 16.5985 9.89122 16.5321 9.62363 16.3983C8.98378 16.0783 8.58642 15.4355 8.58642 14.7192V9.35402C8.58642 8.63874 8.98381 7.99488 9.62363 7.67496C10.2635 7.35403 11.017 7.42144 11.5904 7.85101L15.1669 10.5341C15.6458 10.8913 15.9195 11.4395 15.9195 12.0371L15.9184 12.0361ZM16.6418 7.48892H20.1217C21.1569 7.48892 22 6.64688 22 5.61064V2.13173C22 1.68705 21.6398 1.3269 21.1952 1.3269C20.7505 1.3269 20.3903 1.68705 20.3903 2.13173V4.63978C18.2092 2.02518 14.995 0.5 11.5372 0.5C5.17511 0.5 0 5.67511 0 12.0362C0 18.3973 5.17511 23.5724 11.5362 23.5724C15.6518 23.5724 19.4799 21.3622 21.5271 17.8039C21.7485 17.4186 21.6167 16.9267 21.2314 16.7043C20.8481 16.484 20.3541 16.6148 20.1328 17.0011C18.3712 20.0625 15.0785 21.963 11.5372 21.963C6.06338 21.963 1.61069 17.5103 1.61069 12.0364C1.60968 6.56256 6.06235 2.10986 11.5362 2.10986C14.5976 2.10986 17.4286 3.50725 19.3058 5.87955H16.6407C16.1961 5.87955 15.8359 6.2397 15.8359 6.68437C15.8359 7.12905 16.1961 7.4892 16.6407 7.4892L16.6418 7.48892Z"/>
        </svg>
    </IconButton>
);


export default RunAgainIcon;
